import { render } from "./Services2Section.vue?vue&type=template&id=d8eb6cd4&scoped=true"
import script from "./Services2Section.vue?vue&type=script&lang=js"
export * from "./Services2Section.vue?vue&type=script&lang=js"

import "./Services2Section.vue?vue&type=style&index=0&id=d8eb6cd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8eb6cd4"]])

export default __exports__